import {
  ORDERS_FULFILLMENT_STATUS,
  UNKNOWN_STATUS,
} from '../../../services/orderService/helpers';

export const statusTitleTranslationKeysMap = {
  [ORDERS_FULFILLMENT_STATUS.Pending]: 'tracker.status.order-pending.title',
  [ORDERS_FULFILLMENT_STATUS.Accepted]: 'tracker.status.order-accepted.title',
  [ORDERS_FULFILLMENT_STATUS.Ready]: 'tracker.status.order-ready.title',
  [ORDERS_FULFILLMENT_STATUS.InDelivery]:
    'tracker.status.order-out-for-delivery.title',
  [ORDERS_FULFILLMENT_STATUS.Fulfilled]: 'tracker.status.order-fulfilled.title',
  [ORDERS_FULFILLMENT_STATUS.Cancelled]: 'tracker.status.order-canceled.title',
  [UNKNOWN_STATUS]: 'tracker.status.order-unknown.title',
} as const;

export const statusDescriptionTranslationKeysMap = {
  [ORDERS_FULFILLMENT_STATUS.Pending]:
    'tracker.status.order-pending.description',
  [ORDERS_FULFILLMENT_STATUS.Accepted]:
    'tracker.status.order-accepted.description',
  [ORDERS_FULFILLMENT_STATUS.Ready]: 'tracker.status.order-ready.description',
  [ORDERS_FULFILLMENT_STATUS.InDelivery]:
    'tracker.status.order-out-for-delivery.description',
  [ORDERS_FULFILLMENT_STATUS.Fulfilled]:
    'tracker.status.order-fulfilled.description',
  [ORDERS_FULFILLMENT_STATUS.Cancelled]:
    'tracker.status.order-canceled.description',
  [UNKNOWN_STATUS]: 'tracker.status.order-unknown.description',
} as const;

export const CONTENT_TEXT = {
  title: 'tracker.page.title',
  errorTitle: 'tracker.page.error.title',
  errorDescription: 'tracker.page.error.description',
  orderNumberLabel: 'tracker.page.order-number.label',
  statusLabel: 'tracker.status.label',
  deliveryDetailsTitle: 'tracker.page.delivery-details.title',
  deliveryAddressLabel: 'tracker.page.delivery-details.address.title',
  deliveryTimeLabel: 'tracker.page.delivery-details.due-by.title',
  pickupDetailsTitle: 'tracker.page.pickup-details.title',
  pickupAddressLabel: 'tracker.page.pickup-details.address.title',
  pickupTimeLabel: 'tracker.page.pickup-details.due-by.title',
};
